
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarIec as ObiRadarIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-iec.js';
 
 
 

 
 export const ObiRadarIec = createComponent({
   react: React,
   tagName: 'obi-radar-iec',
   elementClass: ObiRadarIecElement,
   events: {
     
   }
  });
 
 